import Image from "../../../../src/components/Image";
import { Tabs, TabList, Tab, TabPanels, TabPanel } from '@reach/tabs';
import * as React from 'react';
export default {
  Image,
  Tabs,
  TabList,
  Tab,
  TabPanels,
  TabPanel,
  React
};